import * as ArtistLink from './ArtistLink';
import * as ArtistAttachment from './ArtistAttachment';
import { take } from '../../util';
import { z } from 'zod';
export const artistSchema = z.object({
    id: z.number().optional(),
    name: z.string(),
    bio: z.string().optional(),
    links: z.array(ArtistLink.artistLinkSchema).optional().default([]),
    attachments: z.array(ArtistAttachment.artistAttachmentSchema).optional().default([]),
});
export const fromGql = (item) => (Object.assign(Object.assign({}, take(item, 'id', 'name', 'bio')), { links: item.links ? ArtistLink.fromGqlCollection(item.links) : [], attachments: item.attachments ? ArtistAttachment.fromGqlCollection(item.attachments) : [] }));
export const fromGqlCollection = (items) => (items || []).map(item => fromGql(item));
//# sourceMappingURL=Artist.js.map